import { useState, useCallback } from 'react';
import { scanLinks } from '../utils/api';

/**
 * Custom hook to trigger link health checks and observe progress
 */
export function useLinkScanner(onScanComplete) {
  const [isScanning, setIsScanning] = useState(false);
  const [progress, setProgress] = useState(0); // 0 to 100
  const [scanResult, setScanResult] = useState(null);
  const [error, setError] = useState(null);

  const triggerScan = useCallback(async () => {
    setIsScanning(true);
    setProgress(15);
    setError(null);
    setScanResult(null);

    try {
      // Step 1: Start batch scan
      setProgress(40);
      const res = await scanLinks({ batch_size: 20, offset: 0 });
      setProgress(85);

      setScanResult(res);
      setProgress(100);

      if (onScanComplete) {
        await onScanComplete(res);
      }
      return { success: true, result: res };
    } catch (err) {
      const msg = err.message || 'Scan failed';
      setError(msg);
      return { success: false, error: msg };
    } finally {
      setTimeout(() => {
        setIsScanning(false);
        setProgress(0);
      }, 600);
    }
  }, [onScanComplete]);

  return {
    isScanning,
    progress,
    scanResult,
    error,
    triggerScan,
    clearResult: () => setScanResult(null)
  };
}
